import { render } from "./MainLanding.vue?vue&type=template&id=4df69d9a&scoped=true"
import script from "./MainLanding.vue?vue&type=script&lang=js"
export * from "./MainLanding.vue?vue&type=script&lang=js"

import "./MainLanding.vue?vue&type=style&index=0&id=4df69d9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df69d9a"]])

export default __exports__